/**
 * An OAuth2 error will come from the authorization server and will have at least an `error` property which will
 * be the error code. And possibly an `error_description` property
 *
 * See: https://openid.net/specs/openid-connect-core-1_0.html#rfc.section.3.1.2.6
 */
export class OAuthError extends Error {
  constructor(public error: string, public error_description?: string) {
    super(error_description || error);
  }
}

const normalizeErrorFn = (fallbackMessage: string) => (
  error: Error | OAuthError | ProgressEvent | unknown
): Error => {
    // if ('error' in error) {
    //   return new OAuthError(error.error, error.error_description);
    // }

    if (error instanceof OAuthError) {
      return new OAuthError(error.error, error.error_description);
    }

    if (error instanceof Error) {
      return error;
    }

  return new Error(fallbackMessage);
};

export const loginError = normalizeErrorFn('Login failed');

export const tokenError = normalizeErrorFn('Get access token failed');

export const signupError = normalizeErrorFn('Unable to complete signup.');

export const confirmSignupError = normalizeErrorFn('Signup Confirmation failed');